module.exports = "/_next/static/images/video_id_7114293937992420650-01cef4d98989d3d169627c9ec582e36c.jpg";